import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class LoadingPanelService {

  private queue = new Set<{[key: string]: number}>();

  private isLoading$$ = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoading$$.pipe(
    debounceTime(300),
    distinctUntilChanged()
  );

  constructor() { }

  start() {
    this.isLoading$$.next(true);
    // console.log('start: ' + DateTime.local().toSQLTime());
  }

  stop() {
    this.isLoading$$.next(false);
    // console.log('stop: ' + DateTime.local().toSQLTime());
  }

  addToQueue(record: {[key: string]: number}) {
    if (!this.queue.has(record)) {
      this.queue.add(record);
      this.start();
    }
  }

  removeFromQueue(record: {[key: string]: number}, stopIfEmptyQueue = true) {
    if (this.queue.has(record)) {
      this.queue.delete(record);
    }
    if (stopIfEmptyQueue && this.queue.size <= 0) {
      this.stop();
    }
  }

}
